import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { apiCommonResponse } from 'src/app/models/apiCommonResponse';
import {
  Attribute,
  AttributeListResponse,
  AttributeValue,
  attributeValueListResponse
} from 'src/app/models/attribute';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttributeService {
  constructor(private http: HttpClient) {}

  getAttributesList(
    id: string,
    query: string
  ): Observable<AttributeListResponse> {
    return this.http
      .get<{
        data: AttributeListResponse;
      }>(`${environment.base_url}getAttributeType/${id}?${query}`)
      .pipe(map(res => res.data));
  }

  deleteAttribute(id: string, query: string): Observable<apiCommonResponse> {
    return this.http.delete<apiCommonResponse>(
      `${environment.base_url}deleteAttributeType/${id}?${query}`
    );
  }

  addAttribute(
    data: Attribute | AttributeValue
  ): Observable<Attribute | AttributeValue> {
    return this.http.post<Attribute | AttributeValue>(
      `${environment.base_url}addAttribute`,
      data
    );
  }

  editAttribute(data: Attribute, id: string): Observable<Attribute> {
    return this.http.put<Attribute>(
      `${environment.base_url}editAttributeType/${id}`,
      data
    );
  }

  statusUpdateAttribute(data: Attribute, id: string): Observable<Attribute> {
    return this.http.put<Attribute>(
      `${environment.base_url}statusUpdateAttribute/${id}`,
      data
    );
  }

  getAttributeValueList(
    id: string,
    query: string
  ): Observable<attributeValueListResponse> {
    return this.http
      .get<{
        data: attributeValueListResponse;
      }>(`${environment.base_url}getAttributeValue/${id}?${query}`)
      .pipe(map(res => res.data));
  }

  editAttributeValue(
    data: AttributeValue,
    id: string
  ): Observable<AttributeValue> {
    return this.http.put<AttributeValue>(
      `${environment.base_url}editAttributeType/${id}`,
      data
    );
  }

  deleteAttributeValue(
    id: string,
    categoryId: string
  ): Observable<apiCommonResponse> {
    return this.http.delete<apiCommonResponse>(
      `${environment.base_url}deleteAttributeType/${id}?categoryId=${categoryId}`
    );
  }
}
